module.exports = __webpack_public_path__ + "img/paso3.886a37f2.svg";